module.exports = __webpack_public_path__ + "img/icon_xigua.1d5e55b5.png";